import { useSelector } from 'react-redux';
import { mapFashionPreference } from '@browsing/utils';
import {
    FashionPreference,
    FashionPreferencesGenderValues,
} from '@shared/types/fashion-preferences';
import { getCustomerFashionPreferences, getGender } from '@client/redux/modules/customer';
import { readSelectedFashionPreference } from '@client/helpers';

export enum CustomerGender {
    MALE = 'MALE',
    FEMALE = 'FEMALE',
}

export interface TopPicks4UGenderData {
    gender: CustomerGender;
    profileFashionPreference: FashionPreferencesGenderValues;
    selectedFashionPreference: FashionPreferencesGenderValues;
}

/**
 * Hook to fetch and compute customer preferences data for TopPicks4U carousel.
 * Centralizes Redux selectors and preference mapping logic.
 *
 * @returns TopPicks4UGenderData object with gender and fashion preferences
 */
export const useTopPicks4UGenderData = (): TopPicks4UGenderData => {
    const gender = useSelector(getGender)?.toUpperCase() as CustomerGender;
    const profileFashionPreference = mapFashionPreference(
        useSelector(getCustomerFashionPreferences)?.[0] || FashionPreference.Womens,
    );
    const selectedFashionPreference = readSelectedFashionPreference();

    return {
        gender,
        profileFashionPreference,
        selectedFashionPreference,
    };
};
